import { useQuery } from 'react-query'
import { QueryNames } from 'Hooks/api/queryNames'
import { getMerchants } from 'Services/JOONAdmin/merchantService'

export const useGetMerchantsQuery = ({
  searchText,
  perPage,
  pageNumber,
  sortOrder
}: {
  perPage?: number
  pageNumber?: number
  searchText?: string
  sortOrder?: 'asc' | 'desc'
}) => {
  return useQuery({
    queryKey: [QueryNames.GetMerchants, searchText, perPage, pageNumber, sortOrder],
    queryFn: async () => {
      const response = await getMerchants({
        searchText,
        perPage,
        pageNumber,
        sortOrder
      })

      return response
    }
  })
}
